import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';

import {
  container,
  above,
  aboveAndRight,
  right,
  below,
  belowAndLeft,
  left,
  multilineText,
  greyContainer,
  whiteContainer,
} from './styles.module.css';

class Tooltip extends PureComponent {
  static position = {
    ABOVE: 'above',
    ABOVE_AND_RIGHT: 'above_and_right',
    RIGHT: 'right',
    BELOW: 'below',
    BELOW_AND_LEFT: 'below_and_left',
    LEFT: 'left',
  };

  render() {
    const {
      className,
      component,
      text,
      multiline,
      position,
      children,
      whiteBackground,
    } = this.props;

    const containerClasses = classNames({
      [className]: true,
      [container]: true,
      [above]: position === Tooltip.position.ABOVE,
      [aboveAndRight]: position === Tooltip.position.ABOVE_AND_RIGHT,
      [right]: position === Tooltip.position.RIGHT,
      [below]: position === Tooltip.position.BELOW,
      [belowAndLeft]: position === Tooltip.position.BELOW_AND_LEFT,
      [left]: position === Tooltip.position.LEFT,
      [greyContainer]: !whiteBackground,
      [whiteContainer]: whiteBackground,
    });
    return (
      <div className={className}>
        <div className={containerClasses}>
          {text && (
            <span className={multiline ? multilineText : ''}>{text}</span>
          )}
          {component && component}
          {children}
        </div>
      </div>
    );
  }
}

export default Tooltip;

Tooltip.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Component to render in tooltip
   */
  component: PropTypes.element,
  /**
   * Text to be rendered within component.
   */
  text: PropTypes.string,
  /**
   * Applies styling with higher lineHeight
   */
  multiline: PropTypes.bool,

  /**
   * Where the position the tool tip in regards to its first position:relative parent.
   */
  position: PropTypes.oneOf(Object.values(Tooltip.position)),
  /**
   * Whether or not to use the white container background
   */
  whiteBackground: PropTypes.bool,
};

Tooltip.defaultProps = {
  className: '',
  component: undefined,
  text: undefined,
  multiline: false,
  position: Tooltip.position.ABOVE,
  whiteBackground: false,
};
